import dayjs from "dayjs";

import { ICustomer } from "@/api/types/customer";

export type ICustomerWeNeed = Omit<ICustomer, "createdAt" | "active" | "isDeleted" | "isTrialUsed" | "role" | "userType"> & {
    subscription?: string,
};
export function createData(data: ICustomer): ICustomerWeNeed {
    const { id, firstName, lastName, phoneNumber, emailVerified, email, state, updatedAt, hasSubscription, activeTier } =
        data;

    const subscription = (() => {
        switch (activeTier) {
            case "trial":
                return "Trial";
            case "normal":
                return "Subscription";
            case "freeCountries":
                return "Free Countries";
            default:
                return "No Subscription";
        }
    })();

    return {
        id,
        firstName,
        lastName,
        phoneNumber,
        emailVerified,
        email: email || "",
        state,
        hasSubscription,
        updatedAt: dayjs(updatedAt).format("YYYY-MM-DD HH:mm"),
        subscription,
        activeTier,
    };
}
